var React = require('react');

function Spa (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M392.33 206.91a298.84 298.84 0 0 0-60.26 45.17A275.45 275.45 0 0 0 288 302.6a282.66 282.66 0 0 0-45-51.45 294 294 0 0 0-59.22-44.39c16.47-70.45 51.75-132.94 96.74-172.07a12 12 0 0 1 15.14 0c44.95 39.16 80.23 101.72 96.67 172.22z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M576 199.82c-.23 27.92-7.13 126.14-88.77 199.3C403.19 481 320 480 288 480s-115.21 1-199.23-80.88C7.14 326 .23 227.74 0 199.82A7.6 7.6 0 0 1 7.75 192c29 .13 135 6.16 213.84 83 33.12 29.64 53.41 63.3 66.41 94.86 13.05-31.56 33.29-65.22 66.41-94.85 78.83-76.84 184.8-82.87 213.84-83a7.6 7.6 0 0 1 7.75 7.81z","className":"fa-primary","key":2})]);
}

Spa.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Spa;

Spa.default = Spa;
